















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { EnumDataTracking } from '@/const/dataTracking';
import { getOS, getRegion, openAPP } from '@/utils';
import Header from '@/components/Header.vue';
import Icon from '@/components/Icon/index.vue';
import ImageCard from '@/components/ImageCard.vue';
import KOLSwiper from '@/components/KOLSwiper.vue';
import Swiper from '@/components/Swiper.vue';
import PurposeSwiper from '@/components/PurposeSwiper.vue';
import StyleSwiper from '@/components/StyleSwiper.vue';
import SharedSwiper from '@/components/SharedSwiper.vue';
import DiamondSwiper from '@/components/DiamondSwiper.vue';
import CustomerSwiper from "@/components/CustomerSwiper.vue";
import WebCustomerSwiper from '@/components/WebCustomerSwiper.vue';
import CampaignSwiper from '@/components/CampaignSwiper.vue';
import {
  SLIDES,
  IMAGE_CARDS,
  KOL_SLIDES,
  EnumOS,
  EnumAPP,
  EnumRegion,
  DEFAULT_REGION,
  SlideItem,
  PURPOSE_SLIDES,
  STYLE_SLIDES,
  SHARED_SLIDES,
  DIAMOND_SLIDES,
  CUSTOMER_SLIDES,
} from '@/const';

@Component({
  name: 'Home',
  components: {
    Header,
    Swiper,
    ImageCard,
    Icon,
    KOLSwiper,
    PurposeSwiper,
    StyleSwiper,
    SharedSwiper,
    DiamondSwiper,
    CustomerSwiper,
    WebCustomerSwiper,
    CampaignSwiper,
  },
})
export default class Home extends Vue {
  slides = SLIDES;
  StyleSlides = STYLE_SLIDES;
  PurposeSlides = PURPOSE_SLIDES;
  imageCards = IMAGE_CARDS;
  KOLSlides = KOL_SLIDES;
  SharedSlides = SHARED_SLIDES;
  DiamondSlides = DIAMOND_SLIDES;
  private CustomerSlides = [
    {
      img: require('@/assets/images/app_customers_say_01.jpg'),
    },
    {
      img: require('@/assets/images/app_customers_say_02.jpg'),
    },
    {
      img: require('@/assets/images/app_customers_say_03.jpg'),
    }
  ];
  EnumDataTracking = EnumDataTracking;

  EnumAPP = EnumAPP;
  OS: EnumOS = EnumOS.Others;
  region: EnumRegion = DEFAULT_REGION;

  private isWeb = window.innerWidth >= 1024;  // 直接在属性初始化时判断设备类型
  private isVideoLoaded = false;
  private shouldLoadVideo = false;
  private videoObserver: IntersectionObserver | null = null;
  private showScrollGuide = true;
  private isVideoFading = false;
  private imageObserver: IntersectionObserver | null = null;
  private loadedImages: Set<string> = new Set();
  private isBase64Fading = false;
  private isBase64Loaded = false;

  // 添加 base64 缩略图（这里使用了高度压缩和模糊的图片，实际尺寸很小）
  private readonly base64Poster = this.isWeb
    ? 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkLzYvLy0vLi44QzxAOEE4Ny42RUhMSk1RV11dXjtKX2RpZGddbV3/2wBDARUXFx4aHh8gIB83ODhNN003N01NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU3/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAb/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k=' // 网页端缩略图
    : 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkLzYvLy0vLi44QzxAOEE4Ny42RUhMSk1RV11dXjtKX2RpZGddbV3/2wBDARUXFx4aHh8gIB83ODhNN003N01NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU3/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAb/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k='; // 移动端缩略图

  private get urlRegion(): EnumRegion | '' {
    return (this.$route.query.region as EnumRegion) || '';
  }

  get isMobile(): boolean {
    return !this.isWeb;
  }

  private openAPP(app: EnumAPP): void {
    openAPP(app, this.OS, this.region);
  }

  clickBanner(slide: SlideItem): void {
    const { openAppType } = slide;

    if (openAppType) {
      this.openAPP(openAppType);
    }
  }

  async mounted(): Promise<void> {
    // 确保在 DOM 更新后再添加动画类
    this.$nextTick(() => {
      document.documentElement.classList.add('page-ready');
    });
    
    // 只保留resize监听，移除初始化检测
    window.addEventListener('resize', this.checkDevice);
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    // 原有的初始化逻辑
    this.OS = getOS();
    if (this.urlRegion && Object.values(EnumRegion).includes(this.urlRegion)) {
      this.region = this.urlRegion;
      return;
    }
    const res = await getRegion();
    if (Object.values(EnumRegion).includes(res)) {
      this.region = res;
    }

    // 初始化视频懒加载
    this.observeVideo();
    // 初始化图片懒加载
    this.initImageLazyLoad();
    
    // 初始化 base64 到占位图的过渡
    this.$nextTick(() => {
      // 给一个很短的延迟，确保 base64 图片已经渲染
      setTimeout(() => {
        this.isBase64Fading = true;
        // 等待过渡完成后标记 base64 已加载完成
        setTimeout(() => {
          this.isBase64Loaded = true;
        }, 600); // 与 CSS 过渡时间匹配
      }, 50);
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
    window.removeEventListener('scroll', this.handleScroll);

    // 清理视频观察器
    if (this.videoObserver) {
      this.videoObserver.disconnect();
    }
    // 清理图片观察器
    if (this.imageObserver) {
      this.imageObserver.disconnect();
    }
  }

  private checkDevice() {
    this.isWeb = window.innerWidth >= 1024;
  }

  private observeVideo() {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.shouldLoadVideo = true;
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    
    const videoContainer = this.$el.querySelector('.video-container');
    if (videoContainer) {
      observer.observe(videoContainer);
    }
  }

  private handleVideoLoaded() {
    // 统一处理网页端和移动端的过渡效果
    this.isVideoFading = true;
    setTimeout(() => {
      this.isVideoLoaded = true;
    }, this.isWeb ? 600 : 400); // 移动端使用更短的过渡时间
  }

  goToSurvey(): void {
    window.location.href = `${window.location.href}contact-us`;
  }

  test() {
    return require('@/assets/imgs/'+this.region+'.gif')
  }

  get videoSrc(): string {
    return this.isWeb
      ? require('@/assets/banner_video/web_compressed.mp4')
      : require('@/assets/banner_video/app_compressed.mp4');
  }

  get shopLink(): string {
    type RegionLinks = Record<EnumRegion.BR | EnumRegion.PH | EnumRegion.MY | EnumRegion.VN | EnumRegion.SG | EnumRegion.TH, string>;

    const webLinks: RegionLinks = {
      [EnumRegion.BR]: 'https://shp.ee/9WvVo1f',
      [EnumRegion.PH]: 'https://shp.ee/9d7m3nL',
      [EnumRegion.MY]: 'https://shp.ee/ak2fgzM',
      [EnumRegion.VN]: 'https://shp.ee/KFpesvp',
      [EnumRegion.SG]: 'https://shp.ee/7j9KoEm',
      [EnumRegion.TH]: 'https://shp.ee/yrREWTc'
    };

    const mobileLinks: RegionLinks = {
      [EnumRegion.BR]: 'https://shp.ee/8Hc9eUK',
      [EnumRegion.PH]: 'https://shp.ee/zGDgwCt',
      [EnumRegion.MY]: 'https://shp.ee/83HY8Fq',
      [EnumRegion.VN]: 'https://shp.ee/gSZAEeZ',
      [EnumRegion.SG]: 'https://shp.ee/cAB4N5H',
      [EnumRegion.TH]: 'https://shp.ee/ChmAdLM'
    };

    // 默认使用新加坡的链接
    const defaultWebLink = webLinks[EnumRegion.SG];
    const defaultMobileLink = mobileLinks[EnumRegion.SG];

    const links = this.isWeb ? webLinks : mobileLinks;
    const defaultLink = this.isWeb ? defaultWebLink : defaultMobileLink;

    return (this.region in links) ? links[this.region as keyof RegionLinks] : defaultLink;
  }

  private WebCustomerSlides = [
    {
      img: require('@/assets/images/web_customers_say_01.jpg'),
    },
    {
      img: require('@/assets/images/web_customers_say_02.jpg'),
    },
    {
      img: require('@/assets/images/web_customers_say_03.jpg'),
    },
  ];

  private CampaignSlides = [
    {
      img: require('@/assets/images/campaign_01.png'),
      alt: 'Lovito x KOL',
      link: this.campaignLink1
    },
    {
      img: require('@/assets/images/campaign_02.png'),
      alt: 'Lovito Carry',
      link: this.campaignLink2
    },
    {
      img: require('@/assets/images/campaign_03.png'),
      alt: 'Lovito REFINE',
      link: this.campaignLink3
    }
  ];

  get posterSrc(): string {
    return this.isMobile 
      ? require('@/assets/images/app_cover.jpg') 
      : require('@/assets/images/web_cover.jpg');
  }

  get campaignLink1(): string {
    type RegionLinks = Record<EnumRegion.BR | EnumRegion.PH | EnumRegion.MY | EnumRegion.VN | EnumRegion.SG | EnumRegion.TH, string>;

    const links: RegionLinks = {
      [EnumRegion.BR]: 'https://shopee.com.br/m/Barbie-Lovito',
      [EnumRegion.PH]: 'https://shopee.ph/m/Barbie-Lovito',
      [EnumRegion.MY]: 'https://shopee.com.my/m/Barbie-Lovito',
      [EnumRegion.VN]: 'https://shopee.vn/m/Barbie-Lovito',
      [EnumRegion.SG]: 'https://shopee.sg/m/Barbie-Lovito',
      [EnumRegion.TH]: 'https://shopee.co.th/m/Barbie-Lovito'
    };

    // 默认使用新加坡的链接
    const defaultLink = links[EnumRegion.SG];
    return (this.region in links) ? links[this.region as keyof RegionLinks] : defaultLink;
  }

  get campaignLink2(): string {
    type RegionLinks = Record<EnumRegion.BR | EnumRegion.PH | EnumRegion.MY | EnumRegion.VN | EnumRegion.SG | EnumRegion.TH, string>;

    const links: RegionLinks = {
      [EnumRegion.BR]: 'https://shopee.com.br/shop/1618672347',
      [EnumRegion.PH]: 'https://shopee.ph/shop/1617761362',
      [EnumRegion.MY]: 'https://shopee.my/shop/1618796114',
      [EnumRegion.VN]: 'https://shopee.vn/shop/1618797292',
      [EnumRegion.SG]: 'https://shopee.sg/shop/1618743778',
      [EnumRegion.TH]: 'https://shopee.co.th/shop/1618624091'
    };

    // 默认使用新加坡的链接
    const defaultLink = links[EnumRegion.SG];
    return (this.region in links) ? links[this.region as keyof RegionLinks] : defaultLink;
  }

  get campaignLink3(): string {
    type RegionLinks = Record<EnumRegion.BR | EnumRegion.PH | EnumRegion.MY | EnumRegion.VN | EnumRegion.SG | EnumRegion.TH, string>;

    const links: RegionLinks = {
      [EnumRegion.BR]: 'https://shp.ee/yu1sdTx',
      [EnumRegion.PH]: 'https://shp.ee/sDM9r8s',
      [EnumRegion.MY]: 'https://shp.ee/YYdUraV',
      [EnumRegion.VN]: 'https://shp.ee/i9xDA9p',
      [EnumRegion.SG]: 'https://shp.ee/HyXw9Vz',
      [EnumRegion.TH]: 'https://shp.ee/wiKb7ar'
    };

    // 默认使用新加坡的链接
    const defaultLink = links[EnumRegion.SG];
    return (this.region in links) ? links[this.region as keyof RegionLinks] : defaultLink;
  }

  private handleScroll() {
    if (window.scrollY > 10) {  // 当滚动超过10px时隐藏
      this.showScrollGuide = false;
      // 移除滚动监听，因为我们不再需要它了
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  private initImageLazyLoad() {
    // 检查浏览器是否支持 Intersection Observer
    if ('IntersectionObserver' in window) {
      this.imageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const img = entry.target as HTMLImageElement;
              if (img.dataset.src) {
                // 开始加载高清图
                this.loadHighResImage(img);
                // 停止观察这个图片
                this.imageObserver?.unobserve(img);
              }
            }
          });
        },
        {
          rootMargin: '50px 0px', // 提前50px开始加载
          threshold: 0.01 // 只要出现一点就开始加载
        }
      );

      // 获取所有需要懒加载的图片
      this.$nextTick(() => {
        const images = document.querySelectorAll('img[data-src]');
        images.forEach(img => {
          this.imageObserver?.observe(img);
        });
      });
    } else {
      // 降级处理：如果不支持 Intersection Observer，直接加载所有图片
      this.$nextTick(() => {
        const images = document.querySelectorAll('img[data-src]');
        images.forEach(img => {
          if (img instanceof HTMLImageElement && img.dataset.src) {
            img.src = img.dataset.src;
          }
        });
      });
    }
  }

  private loadHighResImage(img: HTMLImageElement) {
    const src = img.dataset.src;
    if (!src || this.loadedImages.has(src)) return;

    // 创建一个新的图片对象来预加载
    const highResImage = new Image();
    
    highResImage.onload = () => {
      // 图片加载完成后，平滑切换
      img.classList.add('lazy-fade-in');
      img.src = src;
      this.loadedImages.add(src);
    };

    highResImage.src = src;
  }

  // 生成缩略图URL的方法（可以根据实际需求调整参数）
  private getThumbnailUrl(originalUrl: string): string {
    // 这里可以根据实际情况处理缩略图URL
    // 例如：添加查询参数来请求较小的图片
    return originalUrl + '?thumbnail=true';
  }
}
